<template>
  <v-card>
    <template v-if="isEditing">
      <v-card-title primary-title class="title">{{ value.branch_name || '-' }}</v-card-title>
      <v-card-text>
        <BranchForm :value="form" @cancel="isEditing = false" @submit="handleFormSubmit" />
      </v-card-text>
    </template>
    <template v-else>
      <v-card-actions class="justify-end" :style="{ flexWrap: 'wrap' }">
        <v-switch
          v-model="isActive"
          :loading="isActiveLoading"
          hide-details
          color="primary"
          class="mt-0"
          @change="handleActiveChange"
        />
        <v-btn icon flat class="ma-0" @click="isEditing = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn icon flat color="error" class="ma-0" @click="$emit('delete', value)">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-title class="title">{{ value.branch_name || '-' }}</v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm6 class="pa-1">
            <label class="d-block">{{ $t('phone no.') }}</label>
            <p class="ma-0">{{ value.phone_number || '-' }}</p>
          </v-flex>
          <v-flex xs12 sm6 class="pa-1">
            <label class="d-block">{{ $t('Address') }}</label>
            <p class="ma-0">{{ value.address_string || '-' }}</p>
          </v-flex>
          <v-flex xs12 class="pa-1">
            <label class="d-block">Google Map</label>
            <p class="ma-0">{{ value.link_google_map || '-' }}</p>
          </v-flex>
          <v-flex xs12 sm6 class="pa-1">
            <label class="d-block">{{ $t('latitude') }}</label>
            <p class="ma-0">{{ value.latitude || '-' }}</p>
          </v-flex>
          <v-flex xs12 sm6 class="pa-1">
            <label class="d-block">{{ $t('longitude') }}</label>
            <p class="ma-0">{{ value.longitude || '-' }}</p>
          </v-flex>
          <v-flex xs12 class="pa-1">
            <label class="d-block">{{ $t('keyword') }}</label>
            <div v-if="value.keywords" :style="{ margin: '-4px' }">
              <v-chip v-for="keyword in value.keywords" :key="keyword" outline>
                {{ keyword }}
              </v-chip>
            </div>
            <p v-else class="ma-0">-</p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import superrichApi from '@/api/superrich'
import BranchForm from './Form.vue'
import { mapGetters } from 'vuex'

export default {
  components: { BranchForm },
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      isActive: this.value.is_used,
      isActiveLoading: false,
      isEditing: false,
      form: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    active(value) {
      this.isActive = value
    },
    isEditing(value) {
      if (value) {
        const {
          branch_name,
          phone_number,
          link_google_map,
          address,
          subdistrict,
          district,
          province,
          postcode,
          latitude,
          longitude,
          keywords
        } = this.value

        this.form = {
          branchName: branch_name,
          phoneNumber: phone_number,
          googleMapUrl: link_google_map,
          address: address,
          subdistrict: subdistrict,
          district: district,
          province: province,
          postcode: postcode,
          latitude: +latitude,
          longitude: +longitude,
          keywords: (keywords || []).map((text) => ({ text }))
        }
      } else {
        this.form = null
      }
    }
  },
  methods: {
    handleActiveChange(value) {
      const setIsActive = (active) => {
        this.isActive = active
      }
      const setIsActiveLoading = (loading) => {
        this.isActiveLoading = loading
      }
      this.$emit('activeChange', this.value, value, { setIsActive, setIsActiveLoading })
    },
    async handleFormSubmit({
      branchName,
      address,
      phoneNumber,
      latitude,
      longitude,
      googleMapUrl,
      district,
      subdistrict,
      province,
      postcode,
      keywords
    }) {
      const { value: isConfirmed } = await this.$swal({
        title: this.$t('branch_edit_question', { name: this.value.branch_name }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (!isConfirmed) return

      const subdistrictPrefix = province === 'กรุงเทพมหานคร' ? 'แขวง' : 'ตำบล'
      const districtPrefix = province === 'กรุงเทพมหานคร' ? 'เขต' : 'อำเภอ'
      const provincePrefix = province === 'กรุงเทพมหานคร' ? '' : 'จังหวัด'
      const fullAddress = [
        address,
        `${subdistrictPrefix}${subdistrict}`,
        `${districtPrefix}${district}`,
        `${provincePrefix}${province}`,
        postcode
      ].join(' ')

      try {
        this.$store.state.loading = true

        const response = await superrichApi.putBranch({
          id: this.value.id,
          page_id: this.selectedBot.pageid,
          branch_name: branchName,
          address: address,
          phone_number: phoneNumber,
          latitude: latitude,
          longitude: longitude,
          link_google_map: googleMapUrl,
          district: district,
          subdistrict: subdistrict,
          province: province,
          postcode: postcode,
          address_string: fullAddress,
          keywords: keywords.map(({ text }) => text)
        })

        if (response.status === 204) {
          this.$emit('edited')
          this.isEditing = false
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.state.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/Item.vue